import React from "react";
import { TextProps } from "./TextProps";
import classes from "./Text.module.scss";
import { clsx } from "clsx";

export const Text: React.FC<TextProps> = ({
  children,
  className,
  as: Component = "p",
  size,
  gutterBottom = false,
  align,
  italic,
  ...rest
}) => {
  const classNames = clsx(
    classes.text,
    size && classes[`text-${size}`],
    align && classes[`align-${align}`],
    gutterBottom && classes.gutter,
    italic && classes.italic,
    className,
  );

  return (
    <Component className={classNames} {...rest}>
      {children}
    </Component>
  );
};
